module.exports = __webpack_public_path__ + "img/chevron-left--white.b1ba3ca5.svg";